export const videolist = [

  {
    image: {
      name: 'logo',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    image2: {
      name2: 'Descripción de la imagen',
      url2: '/img/help_center/video.png'
    },
    description: 'BASYS Sistema administrativo de basculas camionras, contrl de inventarios materiales reciclados'
  },
  {
    image: {
      name: 'logo',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    image2: {
      name2: 'Descripción de la imagen',
      url2: '/img/help_center/video.png'
    },
    description: 'BASYS Sistema administrativo de basculas camionras, contrl de inventarios materiales reciclados'
  },
  {
    image: {
      name: 'logo',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    image2: {
      name2: 'Descripción de la imagen',
      url2: '/img/help_center/video.png'
    },
    description: 'BASYS Sistema administrativo de basculas camionras, contrl de inventarios materiales reciclados'
  },
  {
    image: {
      name: 'logo',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    image2: {
      name2: 'Descripción de la imagen',
      url2: '/img/help_center/video.png'
    },
    description: 'BASYS Sistema administrativo de basculas camionras, contrl de inventarios materiales reciclados'
  },
  {
    image: {
      name: 'logo',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    image2: {
      name2: 'Descripción de la imagen',
      url2: '/img/help_center/video.png'
    },
    description: 'BASYS Sistema administrativo de basculas camionras, contrl de inventarios materiales reciclados'
  },
  {
    image: {
      name: 'logo',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    image2: {
      name2: 'Descripción de la imagen',
      url2: '/img/help_center/video.png'
    },
    description: 'BASYS Sistema administrativo de basculas camionras, contrl de inventarios materiales reciclados'
  },
  {
    image: {
      name: 'logo',
      url: '/img/logo.png'
    },
    title: 'Sistema puento de venta para chatarreras y básculas',
    image2: {
      name2: 'Descripción de la imagen',
      url2: '/img/help_center/video.png'
    },
    description: 'BASYS Sistema administrativo de basculas camionras, contrl de inventarios materiales reciclados'
  }

]
